import { TopBar } from "@/components/common/TopBar"
import { Box } from "@mui/material"
import React, { PropsWithChildren } from "react"

export const LayoutWrapper: React.FunctionComponent<PropsWithChildren> = ({
  children,
}) => {
  return (
    <Box className="h-available flex flex-col overflow-auto">
      <TopBar />
      <Box
        className="flex-1 bg-repeat-y p-5 sm:px-16 sm:py-10"
        sx={{
          backgroundImage: "url(/images/bk.png)",
          backgroundPosition: "top center",
          backgroundSize: "100% auto",
        }}
      >
        <div className="h-full bg-white rounded-3xl w-full shadow-lg min-h-[460px] sm:min-h-auto">
          {children}
        </div>
      </Box>
    </Box>
  )
}
